import {action, observable, makeObservable} from "mobx";
import ListItem from "@arcgis/core/widgets/LayerList/ListItem";

export class LayerListStore {
    hasGroups: boolean;
    isLoading: null | boolean;
    processing: boolean;
    regroupedItems = observable.map<string, ListItem>();
    viewModel: __esri.LayerListViewModel;
    constructor() {
        makeObservable(this, {
            hasGroups: observable,
            isLoading: observable,
            processing: observable,
            regroupedItems: observable,

            setHasGroups: action,
            setIsLoading: action,
            setProcessing: action
        });
        this.setIsLoading(null);
    }
    addRegroupedItem(key: string, regroupedItem: ListItem){
        this.regroupedItems.set(key, regroupedItem);
    }
    setHasGroups(hasGroups: boolean) {
        this.hasGroups = hasGroups;
    }
    setIsLoading(isLoading: boolean | null) {
        this.isLoading = isLoading;
    }
    setProcessing(processing: boolean) {
        this.processing = processing;
    }
    setViewModel(viewModel: __esri.LayerListViewModel) {
        this.viewModel = viewModel;
    }
}
